import type { TableConfig } from '@/shared/lib/table';

const NEWEST_FIRST = { id: 'start' as const, desc: true };

export const phrTableConfigs: Record<string, TableConfig> = {
  conditions: {
    columnOrder: ['name', 'status', 'classification', 'start', 'end'],
    globalSearchKeys: ['name'],
    sortableColumns: ['name', 'status', 'classification', 'start', 'end'],
    defaultSort: NEWEST_FIRST,
    badgeColumns: ['status'],
    columnLayout: {
      name: { maxWidthClass: 'max-w-[420px]', wrap: true },
    },
  },
  labs: {
    transform: 'pivotByStartDate',
    transformOptions: { idPrefix: 'lab' },
    columnOrder: ['name'],
    defaultSort: NEWEST_FIRST,
    globalSearchKeys: ['name'],
    hiddenColumns: ['id'],
    headerByColumn: { name: '' },
    sortableColumns: [],
    columnLayout: {
      name: { maxWidthClass: 'max-w-[360px]', wrap: true, sticky: true },
    },
  },
  medications: {
    columnOrder: ['name', 'status', 'dosage_instructions', 'start', 'end'],
    globalSearchKeys: ['name', 'dosage_instructions'],
    sortableColumns: ['name', 'status', 'start', 'end'],
    defaultSort: NEWEST_FIRST,
    badgeColumns: ['status'],
    columnLayout: {
      name: { maxWidthClass: 'max-w-[360px]', wrap: true },
      dosage_instructions: { maxWidthClass: 'max-w-[520px]', wrap: true },
    },
  },
  notes: {
    columnOrder: ['title', 'start', 'end', 'authors', 'name'],
    globalSearchKeys: ['title', 'description', 'authors', 'name'],
    hiddenColumns: ['description'],
    sortableColumns: ['title', 'start', 'end', 'name'],
    defaultSort: NEWEST_FIRST,
    columnLayout: {
      title: { maxWidthClass: 'max-w-[420px]', wrap: true },
      authors: { maxWidthClass: 'max-w-[260px]', wrap: true },
      name: { maxWidthClass: 'max-w-[260px]', wrap: true },
    },
  },
  procedures: {
    columnOrder: ['name', 'status', 'start', 'end', 'performers'],
    globalSearchKeys: ['name', 'performers'],
    sortableColumns: ['name', 'status', 'start', 'end'],
    defaultSort: NEWEST_FIRST,
    badgeColumns: ['status'],
    columnLayout: {
      name: { maxWidthClass: 'max-w-[520px]', wrap: true },
      performers: { maxWidthClass: 'max-w-[260px]', wrap: true },
    },
  },
  vitals: {
    transform: 'pivotByStartDate',
    transformOptions: { unitKey: 'unit', idPrefix: 'vital' },
    columnOrder: ['name'],
    defaultSort: NEWEST_FIRST,
    globalSearchKeys: ['name'],
    hiddenColumns: ['id', 'unit'],
    headerByColumn: { name: '' },
    sortableColumns: [],
    columnLayout: {
      name: { maxWidthClass: 'max-w-[360px]', wrap: true, sticky: true },
    },
  },
};
